import { IFilterElement } from "@saleor/components/Filter";
import { CountryFilterKeys, CountryListFilterOpts } from "@saleor/countries/components/CountryListPage/filters";
import { CountryListUrlFilters, CountryListUrlFiltersEnum, CountryListUrlQueryParams } from "@saleor/countries/urls";
import { maybe, parseBoolean } from "@saleor/misc";
import { CountryFilterInput } from "@saleor/types/globalTypes";
import {
    createFilterTabUtils,
    createFilterUtils,
    getSingleValueQueryParam
  } from "@saleor/utils/filters";
  
export const ATTRIBUTE_FILTERS_KEY = "countryFilters";
export function getFilterOpts(
    params:CountryListUrlFilters
):CountryListFilterOpts{
    return{
        enable:{
            active: params.enable !== undefined,
            value: maybe(() => parseBoolean(params.enable, true))
        }
    }
}

export function getFilterVariables(
    params:CountryListUrlFilters
):CountryFilterInput{
    return{
      enable:
        params.enable !== undefined
         ?parseBoolean(params.enable, false)
         : undefined,
     search: params.query
    }
}

export const {
  deleteFilterTab, 
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<CountryListUrlFilters>(ATTRIBUTE_FILTERS_KEY);

export const {areFiltersApplied, getActiveFilters } = createFilterUtils<
 CountryListUrlQueryParams,
 CountryListUrlFilters
>( CountryListUrlFiltersEnum);

export function getFilterQueryParam(
    filter: IFilterElement<CountryFilterKeys>
  ): CountryListUrlFilters {
    const { name } = filter;
  
    switch (name) {
      case CountryFilterKeys.enable:
        return getSingleValueQueryParam(
          filter,
          CountryListUrlFiltersEnum.enable
        );
    }
  }
  